import { getEnv } from 'configs/env';
import React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthRouteKeys, MainRouteKeys } from 'routes/enums';
import { OpenAPI } from 'services/openapi/core/OpenAPI';
import { hasAuthenticatedSession } from 'utils/helpers';

const AuthWrapper = (props: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  OpenAPI.BASE = getEnv('REACT_APP_URL_API_MAIN_CLIENT_SIDE');
  OpenAPI.WITH_CREDENTIALS = true;
  OpenAPI.CREDENTIALS = 'include';

  OpenAPI.HEADERS = {
    'Accept-Language': 'vi',
    'X-Client-Type': 'web',
  };

  useEffect(() => {
    let isActive = true;

    async function verifyLogin() {
      const isAuthRoute = location.pathname.startsWith(AuthRouteKeys.Root);
      const isAuthenticated = await hasAuthenticatedSession();
      if (!isActive) return;

      if (isAuthenticated) {
        if (isAuthRoute || location.pathname === MainRouteKeys.Root) {
          navigate(MainRouteKeys.Personal, { replace: true });
          return;
        }
      } else if (!isAuthRoute) {
        navigate(AuthRouteKeys.Login, { replace: true });
      }
    }
    verifyLogin();

    return () => {
      isActive = false;
    };
  }, [location.pathname, navigate]);

  return <>{props.children}</>;
};

export default AuthWrapper;
